/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.TransportMasterResponseDto>>;
export function request(
  params: API.tms.transportMaster.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
